module.exports = __webpack_public_path__ + "img/refunded_label.ef8f908f.png";